<template>
    <form class="form">
        <div class="form__item">
            <div class="form__radio is-inline" v-for="option in question.options" :key="option.id">
                <input
                    type="radio"
                    class="form__radio__input"
                    v-model="question.answer"
                    :id="`q_${question.id}_rb_o_${option.id}`"
                    :value="`q_${question.id}_rb_o_${option.id}`"
                    :disabled="locked">
                <label class="form__radio__label" :for="`q_${question.id}_rb_o_${option.id}`">{{option.label}}</label>
            </div>
        </div>
    </form>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Model } from 'vue-property-decorator';

    @Component
    export default class SurveyTemplateQuestionForm extends Vue {
        @Model('change', { type: Object, default() {
            return {
                options:  []
            };
        }})
        question;

        @Prop() locked;

    }
</script>



// WEBPACK FOOTER //
// src/components/forms/survey/SurveyQuestionLikertForm.vue